/**
 * 1OS Engine Registry
 * ====================
 * Central source of truth for engine identity. Every OneOSLoginShell consumer
 * pulls engine metadata from here. 3-letter codes are MANDATORY and must be
 * uppercase.
 */
export const ENGINES = {
  inventory: { code: "INV", full: "Inventory" },
  sales: { code: "SAL", full: "Sales Capture" },
  accounts: { code: "ACC", full: "Accounts" },
  expense: { code: "EXP", full: "Expense Capture" },
  people: { code: "HR", full: "People" },
  control: { code: "CTRL", full: "Control Room" },
};

export default ENGINES;
